import jQuery from 'jquery'

jQuery(function ($) {
  let $rows

  const setEvents = function () {
    $rows.each((index, el) => {
      const $box = $(el)
      if ($box.innerHeight() >= 300) {
        $box.addClass('is_clickable')
        $box.on('click', function () {
          const $el = $(this)
          const $popup = $('#popupTemplate')
          const $inner = $popup.find('[data-popup="content"]')
          const $close = $popup.find('[data-popup="close"]')

          $close
            .on('mouseenter mouseleave', () => {
              $popup.toggleClass('reduce_opacity')
            })
            .one('click', () => {
              $popup.removeClass('is_active')
            })

          $inner.html($el.html())
          $popup.addClass('is_active')
        })
      }
    })
  }

  const quotesInterval = setInterval(() => {
    $rows = $('.romw-text')
    if ($rows.length) {
      clearInterval(quotesInterval)
      setEvents()
    }
  })
})
